import React, { useState, useEffect } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { Formik, Field, Form, FormikHelpers } from "formik";
import DyButton from "../../../../../components/GlobalComponents/DyButton/DyButton";
import { ReactComponent as AddMeetingVector } from "../../../Statics/Svg/CreateMeeting.svg";
import {
  useGetAllTeamsForSelByTenantId,
  useGetAllMeetingsTypeByTenantId,
  useAddMeeting,
} from "../../../Hooks/index";
import FormikControl from "../../../../../components/FormikControls/FormikControl";
import MultiSelect from "../../../../../components/FormikControls/MultiSelect/MultiSelect";
import DateFieldValue from "../../../../../components/FormikControls/DateField/DateField";
import { useSelector } from "react-redux";
import TextField from '@mui/material/TextField';
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import AddMeetingSuccess from "../../AddMeetingSuccess/AddMeetingSuccess";
import { CircularProgress } from "@mui/material";
import { addMeetingSchema } from "../../../MeetingCard/StaticData";
import MultiSel from "../../../../../components/MultiSel/MultiSel";
import {
  getAllTeamsForSelByTenantId,
  getAllTeamsForSelByTenantIdNew,
} from "../../../Api/Index";
import Loading from "../../../../../components/Loading/Loading";
import DYToastMessage from "../../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
// import

interface Values {
  name: string;
  periodId: string;
  meetingTypeId: string;
  tenantId: string;
  meetingDate: string | any;
  fromTime: any;
  toTime: any;
  meetingRepeatType: string;
  description: string;
  teamIds: any;
  personIds: any;
  // email: string;
}

const AddMeeting = ({
  hideModal,
  meetingLenght,
  setReloadMeetingData,
  setMeetingAsyncState,
  setShowToastMessage2,
  profileTenantId,
  onSuccess,
  onClose
}: any) => {
  // const profileTenantId = sessionStorage.getItem("tenantId");
  // const profileTenantId: any = useSelector(
  //   (state: any) => state.meetings.profileTenantId
  // );
  const licenseType: any = useSelector(
    (state: any) => state.meetings.meetingsList?.licenseType
  );
  // console.log(licenseType)
  const priodId: any = useSelector((state: any) => state.meetings.priodId);
  const [showٍErrorToastMessage, setShowErrorToastMessage] =
    useState<boolean>(false);

  const meetingData: Values = {
    name: "Check_in",
    description: "",
    meetingTypeId: "22e56360-33aa-432f-8c50-034e6c2008d1",
    // meetingTypeId: "",
    periodId: priodId,
    tenantId: profileTenantId!,
    meetingDate: "",
    fromTime: "",
    toTime: "",
    meetingRepeatType: "",
    teamIds: [],
    personIds: [],
  };
  const [confrimForm, setConfrimForm] = useState<string>(licenseType);
  const [addMeetingStatus, setAddMeetingStatus] = useState<any>(null);
  const [allTeamsData, setAllTeamsData] = useState<any>(null);
  const [addMeetingMessage, setAddMeetingMessage] = useState<any | null>(null);
  const [isSucces, SetIsSuccess] = useState<boolean>();
  const [tMessage, SetTMessage] = useState<string>();
  const [showLtoastMessage, setShowLtoastMessage] = useState<any>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [selectedRowData, setSelectedRowData] = React.useState<any>([]);

  const addMeetingSuccess = () => {
    setReloadMeetingData((prev: any): any => !prev);
    hideModal((prev: any): any => !prev);
  };
  const {
    mutate: addMeeting,
    isLoading: AddLoading,
    data: addMeetData,
    status,
    isSuccess,
  } = useAddMeeting(addMeetingSuccess);

  // const { data: allTeamsData, isFetching: isFetchingTeamData } =
  //   useGetAllTeamsForSelByTenantId(profileTenantId);

  const { data: allmeetingTypeData } =
    useGetAllMeetingsTypeByTenantId(profileTenantId);
  const [teamIds, setTeamIds] = useState<any[]>([]);
  const [repeatType, setRepeatType] = useState<any[]>([]);
  const repeatTypeData = [
    { key: "بدون تکرار", value: "none" },
    { key: "هفتگی", value: "OnOneWeekDay" },
    { key: "دو هفته یکبار", value: "OneTwoWeekDay" },
    { key: "چهار هفته یکبار", value: "OneOneMonthDay" },
  ];

  const initialCreateMeeting = () => {
    setConfrimForm("Premium");
  };

  const[repoData,setRepoData]=useState<any>();
  useEffect(() => {
    if(allmeetingTypeData !== null && allmeetingTypeData !== undefined ){
    //  var t = reportingPeriodData?.map((item:any)=>{
    //     let{key,value}=item;
    //     return {year:value,title:key}
    //   })
      setRepoData(allmeetingTypeData);
    }
  }, [allmeetingTypeData]);

  useEffect(() => {
    if (repeatTypeData) {
      setRepeatType(repeatTypeData);
    }
  }, [repeatTypeData]);

  // useEffect(() => {
  //   if (AddLoading) {
  //     setConfrimForm("loading");
  //   }
  // }, [AddLoading]);

  // useEffect(() => {
  //   console.log(teamIds);
  // }, [teamIds]);

  useEffect(() => {
    const apiCall = async () => {
      try {
        const { data } = await getAllTeamsForSelByTenantIdNew(profileTenantId);
        const readyData = data.data.map(({ id, name }: any) => {
          return {year:id,title:name}
          // return { key: name, value: id };
        });
        setAllTeamsData(readyData);
      } catch (error) {
        setShowErrorToastMessage(true);
      }
    };
    apiCall();
  }, []);

  useEffect(() => {
    if (addMeetData) {
      if (addMeetData?.data.isSuccess) {
        // hideModal((prev: any): any => !prev);
        // setMeetingAsyncState(addMeetData?.data);
        // setShowToastMessage(true);
        setShowToastMessage2(true);
        SetIsSuccess(true);
        SetTMessage(addMeetData?.data.metaData.message);
        onSuccess();
        onClose(false);
      } else {
        // setLShowToastMessage(true);
        // setEditAsyncData(editKrData?.data)
        setShowLtoastMessage(true);
        SetIsSuccess(false);
        SetTMessage(addMeetData?.data.metaData.message);
      }
    }
  }, [addMeetData, isSuccess]);

  const initialCancel = () => {
    hideModal(false);
  };

  const initialAddMeeting = (data: any) => {
    if (isSubmitting) return; // جلوگیری از ثبت مجدد
    setIsSubmitting(true); // تغییر وضعیت به در حال ثبت
    // data.teamIds = teamIds.map(({ value }) => value);
    // data.teamIds = selectedRowData.map(({ value } : any) => value);
    data.teamIds = selectedRowData;
    addMeeting(data);
  };
  useEffect(() => {
    if (addMeetData) {
      // ...
      setIsSubmitting(false); // بازنشانی وضعیت پس از ثبت
    }
  }, [addMeetData]);
  
  useEffect(() => {
    if (showLtoastMessage) {
      const timer = setTimeout(() => {
        setShowLtoastMessage(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showLtoastMessage]);
  const renderContent = () => {
    // switch (confrimForm) {
    //   case "Free":
    //     return (
    //       // <AddMeetingSuccess/>
    //       <Box width={"100%"} display={"flex"} flexDirection={"column"}>
    //         <Box p={2}>
    //           <Typography fontWeight={800} variant="h6">
    //             توجه در مورد تعداد جلسات:
    //           </Typography>
    //         </Box>
    //         <Box px={2}>
    //           <Typography variant="body1">
    //             شما اکانت رایگان در اختیار دارید و تنها یک جلسه در هر دوره زمانی
    //             میتوانید ایجاد کنید. با ورود به سایت میتوانید برای ارتقا اکانت
    //             خود اقدام نمایید.
    //           </Typography>
    //         </Box>
    //         <Box
    //           py={3}
    //           mx={"auto"}
    //           columnGap={3}
    //           display={"flex"}
    //           justifyContent={"center"}
    //           textAlign={"center"}
    //         >
    //           {meetingLenght === 0 && (
    //             <DyButton
    //               caption={"جلسه جدید"}
    //               color={"#00387C"}
    //               onClick={initialCreateMeeting}
    //               disbled={false}
    //               variant={"contained"}
    //               bgColor={"#00387C"}
    //               type={"submit"}
    //             />
    //           )}

    //           <a
    //             target="_blank"
    //             style={{ textDecoration: "none" }}
    //             rel="noopener noreferrer"
    //             href="https://okrcoach.ir/"
    //           >
    //             <Button
    //               variant={"contained"}
    //               sx={{ bgcolor: "#00387C", width: "130px", px: 3, py: 0.5 }}
    //             >
    //               ورود به سایت
    //             </Button>
    //           </a>
    //         </Box>
    //       </Box>
    //     );

      // case "Premium":
        return (
          <Formik
            enableReinitialize
            initialValues={meetingData}
            validationSchema={addMeetingSchema}
            onSubmit={(data) => {
              initialAddMeeting(data);
              // console.log(data)
            }}
          >
            {({
              values,
              setFieldValue,
              dirty,
              isValid,
              touched,
              errors,
              setFieldTouched,
            }) => (
              <Form>
                {allTeamsData ? (
                  <Grid container>
                    {/* <Grid item xs={12} md={12}>
                      <Box sx={{ padding: "8px" }}>
                        <MultiSel
                          data={allTeamsData}
                          label={"انتخاب سطح"}
                          extractTag={setTeamIds}
                        />
                      </Box>
                    </Grid> */}

                    {/* <Grid item xs={12} md={6}>
                     <Box sx={{ padding: "15px" }}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                        نوع جلسه {" "}
                        </InputLabel>
                        <Select
                          sx={{
                            "& .muirtl-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select":
                              { py: "7px" },
                          }}
                          size="small"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={values?.meetingTypeId || ""}
                            label="نوع جلسه"
                          onChange={({ target }: any) => {
                            let { value } = target;
                            // setreportingPeriod(value);
                            setFieldValue("meetingTypeId", value);
                          }}
                        >
                          {repoData.map((item: any, i: number) => {
                            let { key, value, desc } = item;
                            return (
                              <MenuItem
                                key={i}
                                sx={{
                                  fontSize: "0.7rem",
                                  bgcolor: "transparent",
                                }}
                                value={value}
                              >
                                {key}
                                {"\u00A0"}
                                <Typography fontSize={"0.5rem"}>
                                  {desc}
                                </Typography>
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                     </Box>
                    </Grid> */}

                    <Grid item xs={12} md={12} >
                      <MultiSelect
                        options={allTeamsData || []}
                        // isLoading={gettenantIndexLoading}
                        //onChangee={setFieldValue}
                        propName='teamIds'
                        label={"انتخاب سطح"}
                        onChangee={(e: any, other: any) => {
                          // let { target } = e;
                          // let { value } = target;
                          // setParentId(value);
                          setSelectedRowData(other);
                        }}
                      />
                    </Grid>  
                     

                    <Grid item xs={12} md={6}>
                      <FormikControl
                        control="select"
                        type="select"
                        label="نحوه تکرار جلسه "
                        options={repeatTypeData}
                        name="meetingRepeatType"
                        fullWidth
                      />
                    </Grid>
                    {/* <Grid item xs={12} md={6}>
                      <Box marginTop={1} width={'425px'}>
                    <TextField 
                    id="meetingRepeatType"
                    select
                    label="نحوه تکرار جلسه "
                    size="small"
                    fullWidth>
          {repeatTypeData.map((options) => (
            <MenuItem key={options.key} value={options.key}>
              {options.key}
            </MenuItem>
          ))}
        </TextField>
        </Box>
        </Grid> */}

                    <Grid item xs={12} md={6}>
                      {/* <DateFieldValue/> */}
                      <FormikControl
                        control="date"
                        label="تاریخ جلسه"
                        name="meetingDate"
                        value={meetingData.meetingDate || ""}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormikControl
                        control="timePicker"
                        name="fromTime"
                        label="ساعت شروع جلسه "
                        value={meetingData.fromTime}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormikControl
                        control="timePicker"
                        name="toTime"
                        label="ساعت پایان جلسه "
                        value={meetingData.toTime}
                      />
                    </Grid>

                    {/* <Grid item xs={12} md={4}>
                      <FormikControl
                        control="timePicker"
                      
                        name="toTime"
                        label='ساعت پایان جلسه '
                        value={meetingData.toTime}
                      />
                    </Grid> */}

                    {/* multiSelect */}
                    <Grid item xs={12}>
                      <FormikControl
                        control="textField"
                        type="text"
                        label="توضیحات"
                        name="description"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} mt={1}>
                      <Box
                        px={1}
                        columnGap={2}
                        display={"flex"}
                        justifyContent={"center"}
                        flexDirection={"row-reverse"}
                      >
                        <Box>
                          <DyButton
                            caption={"ذخیره"}
                            color={"#00387C"}
                            onClick={() => {}}
                            disabled={!dirty || !isValid || isSubmitting} // غیرفعال کردن دکمه در صورت در حال ثبت
                            variant={"contained"}
                            bgColor={"#00387C"}
                            type={"submit"}
                          />
                        </Box>

                        <Box>
                          <DyButton
                            caption={"انصراف"}
                            // color={'#00387C'}
                            // onClick={loginHandler}
                            disbled={false}
                            variant={"outlined"}
                            onClick={initialCancel}
                          />
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                ) : (
                  <div className="h-full w-full flex items-center justify-center">
                    <span className="loading loading-ring loading-lg"></span>
                  </div>
                )}

                {/* <Button color='info' type='submit'  >
                    test
                  </Button> */}
              </Form>
            )}
          </Formik>
        );

        //break;

      // case "loading":
      //   return (
      //     <Box textAlign={"center"} py={4}>
      //       {
      //         <Typography
      //           variant="body1"
      //           fontWeight={700}
      //           color={addMeetingStatus ? "green" : "red"}
      //         >
      //           {addMeetingMessage}
      //         </Typography>
      //       }
      //     </Box>
      //   );
    //}
  };

  // if (AddLoading) {
  //   return (
  //     <Box width={"100%"} py={5} textAlign={"center"}>
  //       <CircularProgress />
  //     </Box>
  //   );
  // }

  return (
    <Box minHeight={"30rem"}>
      <Grid container>
        <Grid item xs={12}>
         <div className="w-full flex justify-center">

          {/* <Box alignSelf={"center"} textAlign={"center"}> */}
            <AddMeetingVector
              style={{
                width: "300px",
                height: "100%",
                alignSelf: "center",
                textAlign: "center",
              }}
              />
              </div>
          {/* </Box> */}
        </Grid>
        <Grid item xs={12}>
          {renderContent()}
        </Grid>
        {/* {addMeetingMessage && (
          <Grid item xs={12}>
            <Box width={"100%"} textAlign={"center"} py={1}>
              <Button
                variant="contained"
                sx={{ bgcolor: "#00387C" }}
                onClick={() => {
                  if (addMeetingStatus) {
                    hideModal((prev: any): any => !prev);
                  } else {
                    setConfrimForm("Premium");
                    setAddMeetingMessage(null);
                  }
                }}
              >
                {addMeetingStatus ? "تایید" : "تلاش مجدد"}
              </Button>
            </Box>
          </Grid>
        )} */}
        {showLtoastMessage && (
          <DYToastMessage
            isSuccess={isSucces}
            message={tMessage}
            setShow={setShowLtoastMessage}
            show={showLtoastMessage}
          />
        )}
      </Grid>
    </Box>
  );
};

export default AddMeeting;
